import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";

Vue.use(Vuetify, {
  iconfont: "md",
  theme: {
    themes: {
      light: {
        primary: "#3dadd8",
        secondary: "#849ca5",
        accent: "#96c254",
        anchor: "#a7ba8b",
      },
      dark: {
        primary: "#3dadd8",
        secondary: "#849ca5",
        accent: "#96c254",
        anchor: "#a7ba8b",
      },
    },
  },
});
